import moment from "moment";
import { useDispatch, useSelector } from "react-redux";

export const RateQuoteMail = async ({ formData, salesPersonList = [], clauses = [] }) => {


    const carrierTab = formData?.CarrierDetails?.map((singlecarrier, key) => {
        const tableHeadHtml = singlecarrier?.rateQuoteContainer
            ?.map(charge => `<th style="padding:12px 8px; text-align:left; font-weight:600; color:#374151; font-size:12px;">${charge?.numberOfContainer} X ${charge?.contTypeName}</th>`)
            .join('');

        const tableRowsHtml = singlecarrier?.rateCharges?.map((charge, index) => {
            const containerCells = singlecarrier?.rateQuoteContainer?.map((c, i) => {
                const rate = charge?.['set' + (i + 1) + 'sellrate'] ?? 0;
                return `<td style="padding:8px 8px; border-bottom:1px solid #e5e7eb;">$${rate.toFixed(2)}</td>`;
            }).join('');
            return `
        <tr>
            <td style="padding:8px 8px; border-bottom:1px solid #e5e7eb;">${charge?.chargedescription || ''}</td>
            <td style="padding:8px 8px; border-bottom:1px solid #e5e7eb;">${charge?.currency || currency}</td>
            <td style="padding:8px 8px; border-bottom:1px solid #e5e7eb;">${charge?.basis || 'per cntr'}</td>
            ${containerCells}
        </tr> `;
        }).join('');

        const grandTotalCellsHtml = singlecarrier?.rateQuoteContainer?.map((c, i) => {
            let grandTotal = 0;

            singlecarrier?.rateCharges?.forEach((charge) => {
                const rate = charge?.['set' + (i + 1) + 'sellrate'] || 0;
                grandTotal += rate;
            });

            return `<td style="padding:12px 8px; border-bottom:1px solid #e5e7eb; font-weight:700;">$${grandTotal.toFixed(2)}</td>`;
        }).join('');


        const vesselInfo = singlecarrier?.ratequoteVessel?.map((v, i) => {
            return `
                <tr style="border-bottom:1px solid #e5e7eb; font-weight:400; color:#4b5563;">
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-left:12px;">
                        ${v?.vesselName || '-'}
                    </td>
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                        ${v?.voyage || '-'}
                    </td>
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                        ${v?.cargoCutoff ? moment(v?.cargoCutoff).format('DD MMM YYYY') : '-'}
                    </td>
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                        ${v?.etd ? moment(v?.etd).format('DD MMM YYYY') : '-'}
                    </td>
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                        ${v?.eta ? moment(v?.eta).format('DD MMM YYYY') : '-'}
                    </td>
                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                        ${v?.transitTime || '-'}
                    </td>
                </tr>
            `;
        }).join('');


        return (
            `
            <!-- Carrier & Ports Section -->
                <table style="width:100%; background-color:#f3f4f6; margin-bottom:24px; border-collapse:collapse;">
                    <tr>
                        <td style="flex:1; padding:8px 12px; font-size:12px; font-weight:600; color:#111827; border-right:1px solid #9ca3af; width:33.3%;">CARRIER: ${singlecarrier?.carrierName}</td>
                        <td style="flex:1; padding:8px 12px; font-size:12px; font-weight:600; color:#111827; border-right:1px solid #9ca3af; width:33.3%;">POL: ${formData?.portOfLoad}</td>
                        <td style="flex:1; padding:8px 12px; font-size:12px; font-weight:600; color:#111827; width:33.3%;">POD: ${formData?.portOfDischarge}</td>
                    </tr>
                </table>

                <!-- Charges Table -->
                <table style="width:100%; border-collapse:collapse; font-size:12px; margin-bottom:24px;">
                    <thead>
                        <tr style="border-bottom:1px solid #d1d5db;">
                            <th style="padding:12px 8px; text-align:left; font-weight:600; color:#374151; font-size:12px;">Charge Description</th>
                            <th style="padding:12px 8px; text-align:left; font-weight:600; color:#374151; font-size:12px;">Currency</th>
                            <th style="padding:12px 8px; text-align:left; font-weight:600; color:#374151; font-size:12px;">Basis</th>
                            ${tableHeadHtml}
                        </tr>
                    </thead>
                    <tbody>
                        ${tableRowsHtml}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td style="padding:12px 8px; border-bottom:1px solid #e5e7eb;"></td>
                            <td style="padding:12px 8px; border-bottom:1px solid #e5e7eb;"></td>
                            <td style="padding:12px 8px; border-bottom:1px solid #e5e7eb; font-weight:700;">Grand Total</td>
                            ${grandTotalCellsHtml}
                        </tr>
                    </tfoot>
                </table>

                <!-- Vessel -->
                <table style="width:100%; margin-bottom:24px; border:1px solid #9ca3af; font-size:11px;">
                    <tr>
                        <td colspan="6" style="background-color:#1a2744; color:white; padding:8px 12px 20px; font-weight:700; font-size:13px; line-height:13px; text-transform:uppercase; letter-spacing:0.05em;">
                            Vessel
                        </td>
                    </tr>
                    <tr style="border-bottom:1px solid #e5e7eb; font-weight:900; color:#4b5563;">
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-left:12px;">
                            Vessel
                        </td>
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                            Voyage
                        </td>
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                            C/O
                        </td>
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                            ETD
                        </td>
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                            ETA
                        </td>
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                            Transit Time
                        </td>
                    </tr>
                    ${vesselInfo}
                </table>
            `
        );
    }).join('');


    const toBase64 = async (url) => {
        const res = await fetch(url, { mode: 'cors' });
        const blob = await res.blob();
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }

    const imageLogoBase64 = await toBase64("/shipez-logo.png");
    const imageLogo = 'http://app.shipez.ai/shipez-logo.png';

    const SalesPersonName = (id) => {
        return salesPersonList.find(item => item.salesPersonId === id)?.salesPerson || "N/A";
    };

    const clausesHtml = clauses?.length > 0 ? clauses.map((clause, index) => {
        return `
            <tr style="border-bottom:1px solid #e5e7eb; font-weight:400; color:#4b5563;">
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-left:12px;">
                    ${clause?.ClauseType || '-'}
                </td>
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                    ${clause?.ModuleType || '-'}
                </td>
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                    ${clause?.ClausesCategoryType || '-'}
                </td>
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                    ${clause?.ClauseDescription || '-'}
                </td>
            </tr>
        `;
    }).join('') : '';

    const cargoHtml = formData?.cargoUnits?.map((unit) => {
        return `
            <tr style="border-bottom:1px solid #e5e7eb; font-weight:400; color:#4b5563;">
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-left:12px;">
                    ${unit?.pices_No || '-'}
                </td>
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                    ${unit?.units_Type || '-'}
                </td>
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                    ${unit?.description || '-'}
                </td>
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                    <table>
                        <tr>
                            <td style="padding:4px 8px; font-weight:600; color:#4b5563;">${unit?.dimensions_L || '-'}</td>
                            <td style="padding:4px 8px; font-weight:600; color:#4b5563;">${unit?.dimensions_W || '-'}</td>
                            <td style="padding:4px 8px; font-weight:600; color:#4b5563;">${unit?.dimensions_H || '-'}</td>
                            <td style="padding:4px 8px; font-weight:600; color:#4b5563;">${unit?.dimensions_Type || '-'}</td>
                        </tr>
                    </table>
                </td>
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                    <table>
                        <tr>
                            <td style="padding:4px 8px; font-weight:600; color:#4b5563;">${unit?.weights_KG || '-'}</td>
                            <td style="padding:4px 8px; font-weight:600; color:#4b5563;">${unit?.weights_LB || '-'}</td> 
                        </tr>
                    </table>
                </td>
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                    <table>
                        <tr>
                            <td style="padding:4px 8px; font-weight:600; color:#4b5563;">${unit?.measurment_CFT || '-'}</td>
                            <td style="padding:4px 8px; font-weight:600; color:#4b5563;">${unit?.measurment_CBM || '-'}</td> 
                        </tr>
                    </table>
                </td>
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                    ${unit?.container_ForUnit || '-'}
                </td>
                <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                    ${unit?.hsCode || '-'}
                </td>
            </tr>
        `;
    }).join('');

    const html = `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Rate Quote</title>
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }
        body {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
            line-height: 1.6;
            color: #333;
            background-color: #f3f4f6;
            padding: 20px;
        }
        table {
            border-collapse: collapse;
        }
    </style>
</head>
<body>
    <table style="width:100%; max-width:100%; margin:0 auto; background-color:white; box-shadow:0 4px 6px rgba(0,0,0,0.1); border:1px solid #e5e7eb;">
        <!-- Header -->
        <tr>
            <td colspan="2" style="padding:24px; border-bottom:1px solid #e5e7eb;">
                <table style="width:100%;">
                    <tr>
                        <td style="width:50%; vertical-align:flex-start;">
                            <img src="${imageLogo}" alt="Company Logo" crossorigin="anonymous" style="height:auto; width:150px;">
                            <div style="font-size:11px; color:#9ca3af; margin-top:4px;">Intelligent Freight Solutions</div>
                        </td>
                        <td style="width:50%; text-align:right; font-size:11px; color:#4b5563; line-height:1.6;">
                            <table style="float:right; text-align:right;">
                                <tr><td style="padding:0;">1074 BROADWAY</td></tr>
                                <tr><td style="padding:0;">SUITE # 200</td></tr>
                                <tr><td style="padding:0;">WEST LONG BRANCH NJ 07764</td></tr>
                                <tr><td style="padding:0;">TEL (732) 283-5300</td></tr>
                                <tr><td style="padding:0;">FAX: (732) 283-2423</td></tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>

        <!-- Content -->
        <tr>
            <td colspan="2" style="padding:24px;">
                <!-- Customer Section -->
                <table style="width:100%; margin-bottom:24px; border:1px solid #9ca3af;">
                    <tr>
                        <td colspan="2" style="background-color:#1a2744; color:white; padding:8px 12px 20px; font-weight:700; font-size:13px; line-height:13px; text-transform:uppercase; letter-spacing:0.05em;">
                            Customer
                        </td>
                    </tr>
                    <tr>
                        <td style="width:50%; padding:12px; font-size:12px; border-right:1px solid #9ca3af;">
                            <div style="font-weight:600; color:#111827; font-size:14px; margin-bottom:8px;">${formData?.customerName}</div>
                            <div style="font-size:11px; color:#374151; line-height:1.6; white-space:pre-wrap; margin-bottom:8px;">${formData?.customerAddress}</div>
                            <div style="margin-bottom:4px; font-size:11px;"><span style="font-weight:600; color:#4b5563;">TEL:</span> <span style="color:#111827;">${formData?.customerTel}</span></div>
                            <div style="font-size:11px; color:#111827;">${formData?.customerEmail}</div>
                        </td>
                        <td style="width:50%; padding:12px; font-size:12px;">
                            <table style="width:100%; font-size:11px; border-collapse:collapse;">
                                <tr style="border-bottom:1px solid #e5e7eb;">
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">RQ NUMBER</td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;">: ${formData?.rateQuoteNumber}</td>
                                </tr>
                                <tr style="border-bottom:1px solid #e5e7eb;">
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">QUOTE DATE</td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;">: ${formData?.createdOn ? moment(formData?.createdOn).format('DD MMM YYYY') : ''}</td>
                                </tr>
                                <tr style="border-bottom:1px solid #e5e7eb;">
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">EFFECTIVE DATE</td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;">: ${formData?.effectiveDate ? moment(formData?.effectiveDate).format('DD MMM YYYY') : ''}</td>
                                </tr>
                                <tr style="border-bottom:1px solid #e5e7eb;">
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">EXPIRY DATE</td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;">: ${formData?.valideDate ? moment(formData?.valideDate).format('DD MMM YYYY') : ''}</td>
                                </tr>
                                <tr style="border-bottom:1px solid #e5e7eb;">
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">QUOTED BY</td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;">: ${formData?.quotedBy}</td>
                                </tr>
                                <tr>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">SALES PERSON</td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;">: ${SalesPersonName(formData?.salesPersonSno)}</td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>

                <!-- Routing Instruction Section -->
                <table style="width:100%; margin-bottom:24px; border:1px solid #9ca3af;">
                    <tr>
                        <td colspan="2" style="background-color:#1a2744; color:white; padding:8px 12px 20px; font-weight:700; font-size:13px; line-height:13px; text-transform:uppercase; letter-spacing:0.05em;">
                            Routing Instruction
                        </td>
                    </tr>
                    <tr>
                        <td style="width:50%; padding:12px; font-size:12px; border-right:1px solid #9ca3af;">
                            <table style="width:100%; font-size:11px; border-collapse:collapse;">
                                <tr style="border-bottom:1px solid #e5e7eb;">
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">MOVE TYPE</td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.moveType}</strong></td>
                                </tr>
                                <tr>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">PLACE OF RECEIPT</td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.origin}</strong></td>
                                </tr>
                                <tr>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;"> PORT OF LOADING</td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.portOfLoad}</strong></td>
                                </tr> 
                                <tr>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;"> TRANSIT TIME</td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.transitTime}</strong></td>
                                </tr>
                            </table>
                        </td>
                        <td style="width:50%; padding:12px; font-size:12px;">
                            <table style="width:100%; font-size:11px; border-collapse:collapse;">
                                <tr style="border-bottom:1px solid #e5e7eb;">
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;"> PORT OF DISCHARGE </td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.portOfDischarge}</strong></td>
                                </tr>
                                <tr>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;"> PLACE OF DELIVERY</td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.destination}</strong></td>
                                </tr>
                                <tr>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;"> LOADING LOCATION</td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.loadingLoc}</strong></td>
                                </tr>
                                <tr>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;"> COMMODITY</td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.commodity}</strong></td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>

                <table style="width:100%; margin-bottom:24px; border:1px solid #9ca3af;">
                    <tr>
                        <td colspan="2" style="background-color:#1a2744; color:white; padding:8px 12px 20px; font-weight:700; font-size:13px; line-height:13px; text-transform:uppercase; letter-spacing:0.05em;">
                            Container & Commodity
                        </td>
                    </tr>
                    <tr>
                        <td style="width:50%; padding:12px; font-size:12px; border-right:1px solid #9ca3af;">
                            <table style="width:100%; font-size:11px; border-collapse:collapse;">
                                <tr style="border-bottom:1px solid #e5e7eb;">
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">COMMODITY</td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.commodity}</strong></td>
                                </tr>
                                <tr style="border-bottom:1px solid #e5e7eb;">
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">TRUCKER</td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.truckerName}</strong></td>
                                </tr>
                                <tr style="border-bottom:1px solid #e5e7eb;">
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">TRUCKER DETAILS</td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.truckerAddress}</strong></td>
                                </tr>
                            </table>
                        </td> 
                        <td style="width:50%; padding:12px; font-size:12px;">
                            <table style="width:100%; font-size:11px; border-collapse:collapse;">
                                <tr style="border-bottom:1px solid #e5e7eb;">
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;"> HAZARDOUS </td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.hazCargo}</strong></td>
                                </tr>
                                <tr style="border-bottom:1px solid #e5e7eb;">
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">  IMO CLASS </td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.imoClass || '-'}</strong></td>
                                </tr>
                                <tr style="border-bottom:1px solid #e5e7eb;">
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">   PKG # </td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.package || '-'}</strong></td>
                                </tr>
                                <tr style="border-bottom:1px solid #e5e7eb;">
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">   UN NBR </td>
                                    <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; color:#111827;"><strong>${formData?.unnbr || '-'}</strong></td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>

                ${carrierTab}
                
                <table style="width:100%; margin-bottom:24px; border:1px solid #9ca3af; font-size:11px;">
                    <tr>
                        <td colspan="8" style="background-color:#1a2744; color:white; padding:8px 12px 20px; font-weight:700; font-size:13px; line-height:13px; text-transform:uppercase; letter-spacing:0.05em; vertical-align:middle;">
                            Cargo Details
                        </td>
                    </tr>
                    <tr  style="border-bottom:1px solid #e5e7eb; font-weight:900; color:#4b5563;">
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-left:12px;">
                            Pc
                        </td>
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                            Pkg
                        </td>
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                            Marks & Numbers
                        </td>
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                            Dimensions
                            <table>
                                <tr>
                                    <td style="padding:4px 8px; font-weight:600; color:#4b5563;">L</td>
                                    <td style="padding:4px 8px; font-weight:600; color:#4b5563;">W</td>
                                    <td style="padding:4px 8px; font-weight:600; color:#4b5563;">H</td>
                                    <td style="padding:4px 8px; font-weight:600; color:#4b5563;">Type</td>
                                </tr>
                            </table>
                        </td>
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                            Weight
                            <table>
                                <tr>
                                    <td style="padding:4px 8px; font-weight:600; color:#4b5563;">KG</td>
                                    <td style="padding:4px 8px; font-weight:600; color:#4b5563;">LB</td> 
                                </tr>
                            </table>
                        </td>
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                            Measurement
                            <table>
                                <tr>
                                    <td style="padding:4px 8px; font-weight:600; color:#4b5563;">CFT</td>
                                    <td style="padding:4px 8px; font-weight:600; color:#4b5563;">CBM</td> 
                                </tr>
                            </table>
                        </td>
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                            Cntr
                        </td>
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                            HS
                        </td>
                    </tr>
                    ${cargoHtml}
                </table>

                <table style="width:100%; margin-bottom:24px; border:1px solid #9ca3af; font-size:11px;">
                    <tr>
                        <td colspan="4" style="background-color:#1a2744; color:white; padding:8px 12px 20px; font-weight:700; font-size:13px; line-height:13px; text-transform:uppercase; letter-spacing:0.05em; vertical-align:middle;">
                            Clause
                        </td>
                    </tr>
                    <tr  style="border-bottom:1px solid #e5e7eb; font-weight:900; color:#4b5563;">
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-left:12px;">
                            CLAUSE TYPE
                        </td>
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                            MODULE TYPE
                        </td>
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                            CLAUSE CATEGORY
                        </td>
                        <td style="vertical-align:top; padding-top:6px; padding-bottom:12px; font-weight:600; color:#4b5563; width:120px; padding-right:12px;">
                            DESCRIPTION
                        </td>
                    </tr>
                    ${clausesHtml}
                </table>

                <!-- Remarks Section -->
                <div style="margin-bottom:24px;">
                    <div style="font-weight:700; font-size:13px; text-transform:uppercase; color:#111827; margin-bottom:12px;">Customer Remarks:</div>
                    <div style="font-size:11px; color:#374151; text-transform:uppercase; line-height:1.6; white-space:pre-wrap;">${formData?.customerRemarks || `BASED ON GENERAL CARGO.\nOCEANFREIGHT IS INCLUSIVE OF BUNKER, ISPS, TERMINAL, PORT, LOW SULFUR AND ENERGY SURCHARGE.`}</div>
                </div>

                <!-- Footer -->
                <table style="width:100%; border-top:1px solid #d1d5db; padding-top:16px; margin-top:24px;">
                    <tr>
                        <td style="padding-right:24px; font-size:11px;">
                            <div style="color:#9ca3af; margin-bottom:4px; font-size:11px;">Prepared By:</div>
                            <div style="font-weight:600; color:#111827; font-size:13px;">${formData?.createdBy}</div>
                            <div style="font-size:11px; color:#6b7280;">Shipez AI</div>
                        </td>
                        <td style="text-align:right; font-size:11px;">
                            <div style="color:#9ca3af; margin-bottom:4px; font-size:11px;">Customer Acceptance:</div>
                            <div style="border-bottom:1px solid #9ca3af; height:24px; margin-bottom:4px;"></div>
                            <div style="font-size:10px; color:#9ca3af;">Signature &amp; Date</div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" style="margin-top:12px; padding-top:12px; border-top:1px solid #e5e7eb; text-align:center; font-size:11px; color:#9ca3af;">
                            Thank you for choosing Shipez AI | www.shipez.ai
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</body>
</html>
`;
    return html;
};